module.exports = __webpack_public_path__ + "static/media/2.6cf04e7e.jpg";